import type { Placement } from "@floating-ui/react";
import type { ReactNode } from "react";
import { TooltipContext } from "./TooltipContext";
import { type TooltipOptions, useTooltip } from "./useTooltip";

export const Tooltip = ({
  children,
  ...options
}: {
  children: ReactNode;
} & TooltipOptions) => {
  const tooltip = useTooltip(options);
  return (
    <TooltipContext.Provider value={tooltip}>
      {children}
    </TooltipContext.Provider>
  );
};

export const TooltipRoot = ({
  children,
  placement,
}: {
  children: ReactNode;
  placement: Placement;
}) => {
  return <Tooltip placement={placement}>{children}</Tooltip>;
};
